import 'antd/dist/antd.less'; // should before the customized style
import { ScrollTop } from 'components/ui/index';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './assets/less/index.less';
import { ErrorNotification } from './components/page/index';
import I18n from './i18n/index';
import configureStore from './store/configureStore';

const store = configureStore();

// 在非生成环境，都打印redux中的state,以便于跟踪调试，在非生产环境中都写入固定cookie用于调试

if (process.env.NODE_ENV !== 'production') {
  store.subscribe(() => {
    // eslint-disable-next-line no-console
    console.log('redux store ===', store.getState());
  });
}

// eslint-disable-next-line no-underscore-dangle
window.__store__ = store;

ErrorNotification(store);

const AppView = () => (
  <Provider store={store}>
    <I18n>
      <BrowserRouter>
        <ScrollTop>
          <App />
        </ScrollTop>
      </BrowserRouter>
    </I18n>
  </Provider>
);
ReactDOM.render(<AppView />, document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js